import React from 'react';
import ListTemplate from '../../../Reusable_Components/ListTemplate';
import { API_ROUTES, API_DOMAIN } from '../../../Reusable_Components/Config/apiConfig';

const ScheduledReportListDetails = () => {
  const columns = [
    { label: 'Report', value: 'report' },
    { label: 'Delivery Schedule', value: 'delivery_schedule' },
    { label: 'Format', value: 'format' },
    { label: 'Recipients', value: 'recipients' },
    { label: 'Access Details', value: (id) => <button onClick={() => handleAccessDetails(id)}>Access Details</button> },
  ];

  const handleAccessDetails = (id) => {
    const encodedId = btoa(id);
    window.location.href = '/reporting/scheduled-report/details/' + encodedId;
  };
  return <ListTemplate columns={columns} onAccessDetails={handleAccessDetails} fetchUrl={API_DOMAIN + API_ROUTES['scheduledReport']} />;
};

export default ScheduledReportListDetails;